import React from 'react'


const Calendar = ({Component, user, select, userdetails, appointments}) => {
  
  return (
    <div className="mt-2 h-max min-h-0 w-full bg-wa-app px-4 pb-10 pt-0 sm:px-8">
      {Component && <Component.viewComponent select={select} appointments={appointments} user={user} userdetails={userdetails}/>}
    </div>
  )
}

export default Calendar
